export enum MediaType {
  Audio = 10,
  EventPlaylist = 32,
  LoopPlaylist = 13,
}
